import afiliados from '@/data/afiliados.json';

/* ═══════════════════════════════════════════
   USE AFFILIATE — Gera links de afiliado
   com UTM dinâmico e tracking
   ═══════════════════════════════════════════ */

interface UtmParams {
  [key: string]: string;
}

interface AffiliateConfig {
  ativo: boolean;
  nome: string;
  descricao: string;
  pcrid?: string;
  linkBase: string;
  utm: UtmParams;
  comissao: string;
  posicoes: string[];
  badge: string;
  aid?: string;
}

interface AffiliatesData {
  vaiDePromo: AffiliateConfig;
  segurosPromo: AffiliateConfig;
  booking: AffiliateConfig;
}

const data = afiliados as AffiliatesData;

function buildQueryString(params: Record<string, string>): string {
  return Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
}

export function generateAffiliateLink(
  provider: keyof AffiliatesData,
  content: string,
  extraParams: Record<string, string> = {}
): string {
  const config = data[provider];
  if (!config || !config.ativo) return config?.linkBase || '#';

  const utm = {
    ...config.utm,
    utm_content: content,
  };

  const allParams: Record<string, string> = {
    ...extraParams,
    ...utm,
  };

  if (provider === 'vaiDePromo' && config.pcrid) {
    allParams.pcrid = config.pcrid;
    allParams.utm_medium = 'afiliado';
  }

  if (provider === 'booking' && config.aid) {
    allParams.aid = config.aid;
  }

  const qs = buildQueryString(allParams);
  const separator = config.linkBase.includes('?') ? '&' : '?';

  return `${config.linkBase}${separator}${qs}`;
}

export function getAffiliateConfig(provider: keyof AffiliatesData): AffiliateConfig | null {
  return data[provider] || null;
}

export function isAffiliateActiveAt(provider: keyof AffiliatesData, position: string): boolean {
  const config = data[provider];
  return !!config && config.ativo && config.posicoes.includes(position);
}

export function useAffiliate() {
  return {
    generateLink: generateAffiliateLink,
    getConfig: getAffiliateConfig,
    isActiveAt: isAffiliateActiveAt,
    data,
  };
}
